export default __webpack_public_path__ + "static/media/still_life_charcoal.d71ebbe9.jpg";